import React, { useRef } from "react";
import useFlipReorder from "../hooks/useFlipReorder";
import { formatCurrency } from "../utils/format";

// Het podium met de top 3, in de volgorde waarin je het op een echt podium
// ziet staan: 2e links, 1e in het midden, 3e rechts.
const podiumOrder = [1, 0, 2];

const Podium = ({ rankList }) => {
  // De staafhoogte volgt het bedrag ten opzichte van de nummer 1. De
  // ondergrens staat in CSS (min-height op .pod-bar), zodat het rangnummer
  // altijd past en de verhouding tussen de bedragen verder eerlijk blijft.
  const topPrice = rankList.length
    ? Math.max(...rankList.slice(0, 3).map((user) => user.totalPrice || 0))
    : 0;

  const barHeight = (price) =>
    !topPrice || !price ? 0 : Math.round((price / topPrice) * 100);

  // Wie op welke trede staat kan tussen twee metingen wisselen. De treden zijn
  // op naam gekoppeld (key + data-flip-key), zodat React hetzelfde element
  // meeneemt naar de nieuwe kolom en de FLIP-laag dat kan uitschuiven.
  const podiumRef = useRef(null);
  const order = podiumOrder.map((index) => rankList[index]?.name || "-").join("|");
  useFlipReorder(podiumRef, order);

  return (
    <div className="podium podium--fill rank-swap" ref={podiumRef}>
      {podiumOrder.map((index, position) => {
        const user = rankList[index];
        // Een trede zonder verkoper blijft staan met een streepje, zodat het
        // podium altijd compleet is.
        const height = user ? barHeight(user.totalPrice) : 0;
        const flipKey = user ? `seller:${user.name}` : `empty:${position}`;

        return (
          <div
            key={flipKey}
            data-flip-key={flipKey}
            className={`pod pod-${index + 1}${user ? "" : " pod-empty"}`}
          >
            {/* data-name op de trede en niet op de kolom: de kolom is altijd
                even hoog, de trede is het vlak dat bij deze verkoper hoort. */}
            <div
              className="pod-bar"
              data-name={user ? user.name : undefined}
              style={{ height: `${height}%` }}
            >
              <div className="pod-label">
                <div className="n">{user ? user.name : "-"}</div>
                <div className="v">€{formatCurrency(user ? user.totalPrice : 0)}</div>
              </div>
              <div className="p">{index + 1}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Podium;
